var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('StreamBarcodeReader',{on:{"decode":_vm.onDecode,"loaded":_vm.onLoaded}}),(_vm.result !== null)?_c('div',[_vm._v(" "+_vm._s(_vm.result)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }